export default __webpack_public_path__ + "static/media/wedding-logo.e10da9ac.png";